import React from "react";
import add from "../../assets/icons/message-manager/add.svg";
import { FormattedMessage } from 'react-intl'

function AddButton({ modalId, labelId, onClick }) {
  return (
    <div className="mt-auto d-flex">
      <button
        className="btn btn-primary add-button btn-primary-style"
        {...(modalId && { 
          "data-bs-toggle": "modal", 
          "data-bs-target": `#${modalId}` 
        })}
        {...(onClick && { onClick })} 
      >
        <img src={add} alt="Send Icon" className="me-2" />
        <FormattedMessage id={labelId} />
      </button>
    </div>
  );
}

export default AddButton;
